export default __webpack_public_path__ + "static/media/Rectangle 27.01b1c33f.png";